var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotification01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.75,
    height: 23,
    viewBox: "0 0 19.75 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17078",
    "data-name": "Group 17078",
    transform: "translate(-19.25 -16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bell",
    transform: "translate(17.25 18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12032",
    "data-name": "Path 12032",
    d: "M18.957,14.8a5.861,5.861,0,0,1-2.082-4.484V7.875a6.13,6.13,0,0,0-5.25-6.055V.875a.875.875,0,1,0-1.75,0V1.82a6.129,6.129,0,0,0-5.25,6.055v2.439a5.867,5.867,0,0,1-2.09,4.491,1.531,1.531,0,0,0,1,2.694H17.969a1.531,1.531,0,0,0,.988-2.7Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12033",
    "data-name": "Path 12033",
    d: "M11.541,23.625A3.286,3.286,0,0,0,14.756,21H8.326A3.286,3.286,0,0,0,11.541,23.625Z",
    transform: "translate(-0.791 -2.625)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_371",
    "data-name": "Ellipse 371",
    transform: "translate(29 16)",
    fill: "#fff",
    stroke: "#ec6321",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 4,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification01);
export default __webpack_public_path__ + "static/media/notification 01.8d58dc4885ae700bfdbedb0468d4af45.svg";
export { ForwardRef as ReactComponent };